export default __webpack_public_path__ + "0b1ee5e82f79bb0ffc785d2fd1f9fbc2.png";